import { render, staticRenderFns } from "./editPermissionForm.vue?vue&type=template&id=410480b1&scoped=true&"
import script from "./editPermissionForm.vue?vue&type=script&lang=js&"
export * from "./editPermissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410480b1",
  null
  
)

export default component.exports